import type { PolicyLevelCoverages } from "@covertree/new-business-graphql";

export const NO_POLICY_LEVEL_COVERAGES = {} as PolicyLevelCoverages;
